// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3J5n-","unreadBadge":"styles_unreadBadge__sBo0X","modalContent":"styles_modalContent__1fi-e","modal":"styles_modal__1xVjB"};